import {
  Avatar,
  Badge,
  Box,
  Button,
  Card,
  Flex,
  Grid,
  Group,
  SegmentedControl,
  Stack,
  Text,
  TextInput,
  ThemeIcon,
} from "@mantine/core";
import React, { useEffect, useState } from "react";
import { FolderOff, GridDots, List, UserPlus, Users } from "tabler-icons-react";

import { useGetProjects } from "api/projects/getProjects";
import MainHeading from "components/MainHeading";
import NotFound from "components/NotFound";
import { useUser } from "hooks/useUser";

import CreateProjectModal from "../CreateProjectModal";
import PageSkeleton from "../PageSkeleton";
import ProjectsTable from "../ProjectsTable";
import styles from "./ProjectManagement.module.css";
import ActionsBtn from "../ProjectsTable/ActionsBtn";
import { textOverlap } from "utils/commonFunction";
import { PermissionButton } from "api/permission/buttonpermission";

export function ProjectManagement() {
  const { user } = useUser();
  const { data, isLoading, isError } = useGetProjects(user.org?._id, user._id);
  const [opened, setOpened] = useState(false);
  const [value, setValue] = useState("grid");

  useEffect(() => {
    const saved = localStorage.getItem("projectView");
    if (saved === "grid" || saved === "list") {
      setValue(saved);
    }
  }, []);
  useEffect(() => {
    localStorage.setItem("projectView", value);
  }, [value]);
  if (user.role === "member") {
    return <NotFound />;
  }

  if (isLoading) {
    return <PageSkeleton />;
  }

  if (isError) {
    return <NotFound />;
  }

  return (
    <Box>
      <MainHeading title="Project Management" />
      <Flex
        justify="space-between"
        align="center"
        direction="row"
        wrap="nowrap"
      >
        <h2 className={styles.title}>All Projects</h2>{" "}
        <PermissionButton
          permission="project_management.create"
          leftIcon={<UserPlus size={16} />}
          onClick={() => setOpened(true)}
        >
          Create Project
        </PermissionButton>
        {/* <Button
          size="md"
          mt={20}
          className={styles.title}
          onClick={() => setOpened(true)}
        >
          Create Project
        </Button> */}
      </Flex>

      <CreateProjectModal
        opened={opened}
        onClose={() => setOpened(false)}
        user={user}
      />

      <Group mb="lg" style={{ justifyContent: "space-between" }}>
        <TextInput placeholder="Search projects..." w={300} disabled />
        <Group>
          <SegmentedControl
            value={value}
            onChange={setValue}
            data={[
              { label: <GridDots size={16} />, value: "grid" },
              { label: <List size={16} />, value: "list" },
            ]}
            defaultValue="grid"
          />
        </Group>
      </Group>
      {value === "list" && (
        <>
          {data.projects.length > 0 && (
            <ProjectsTable projects={data.projects} orgId={user.org?._id} />
          )}
          {data.projects.length === 0 && (
            <Stack align="center" py={30} spacing={10}>
              <FolderOff color="#5C5F66" size={32} />
              <Text align="center" weight={600} color="dark.3">
                No projects created
              </Text>
            </Stack>
          )}
        </>
      )}
      {value === "grid" && (
        <Grid gutter="lg">
          {value === "grid" && (
            <>
              {data.projects.length === 0 && (
                <Stack align="center" py={30} spacing={10}>
                  <FolderOff color="#5C5F66" size={32} />
                  <Text align="center" weight={600} color="dark.3">
                    No projects created
                  </Text>
                </Stack>
              )}
              {data.projects.length > 0 &&
                data.projects.map((proj) => (
                  <Grid.Col span={4} key={proj._id}>
                    <Card withBorder radius="md" p="md">
                      <Group
                        style={{ justifyContent: "space-between" }}
                        align="flex-start"
                      >
                        <Stack spacing={4}>
                          <Group spacing={6}>
                            <Text fw={600}>{proj.name}</Text>
                            <Text c="yellow">⭐</Text>
                          </Group>
                          <Text size="sm" c="dimmed">
                            {textOverlap(proj.description, 100)}
                          </Text>
                        </Stack>
                        <Badge color="yellow">In Progress</Badge>
                      </Group>
                      <Group spacing="xs" mt="sm">
                        <ThemeIcon variant="light" color="gray" size="sm">
                          <Users />
                        </ThemeIcon>
                        <Group spacing={-5}>
                          <Group spacing={-5}>
                            {proj.members.slice(0, 4).map((member) => (
                              <Avatar key={member._id} size="sm" radius="xl">
                                {member.firstName.charAt(0)}
                              </Avatar>
                            ))}

                            {proj.members.length > 4 && (
                              <Avatar size="sm" radius="xl" color="gray">
                                +{proj.members.length - 4}
                              </Avatar>
                            )}
                          </Group>
                        </Group>
                        <ActionsBtn
                          project={proj}
                          // projectId={proj._id}
                          orgId={user.org?._id}
                          projects={data.projects}
                          type={value}
                        />
                      </Group>
                      <Group
                        style={{ justifyContent: "space-between" }}
                        mt="sm"
                      >
                        <Group>
                          <Text size="xs" c="dimmed">
                            {proj.todoIssues.length} Todo
                          </Text>
                          <Text size="xs" c="dimmed">
                            {proj.inProgressIssues.length} In Progress
                          </Text>
                          <Text size="xs" c="dimmed">
                            {proj.inReviewIssues.length} In Review
                          </Text>
                          <Text size="xs" c="dimmed">
                            {proj.completedIssues.length} Done
                          </Text>
                        </Group>
                      </Group>

                      <Group
                        mt="sm"
                        spacing="md"
                        style={{ justifyContent: "space-between" }}
                      >
                        <Stack spacing={2}>
                          <Text size="xs" c="dimmed">
                            Client
                          </Text>
                          <Text size="sm">Nomad Strategies</Text>
                        </Stack>
                        <Stack spacing={2}>
                          <Text size="xs" c="dimmed">
                            Priority
                          </Text>
                          <Badge color="red">High</Badge>
                        </Stack>
                      </Group>
                    </Card>
                  </Grid.Col>
                ))}
            </>
          )}
        </Grid>
      )}
    </Box>
  );
}
